module.exports = __webpack_public_path__ + "static/media/verzeo.5a970482.png";